import {createAction, props} from '@ngrx/store';
import {SignatureTemplate} from '@automata/models/signature-template';

export const LoadContracts = createAction('[Contracts] Load Start');
export const LoadContractsComplete = createAction('[Contracts] Load Complete', props<{templates: SignatureTemplate[]}>());
